import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment.prod';
// import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  serversIpAddress: string = environment.serversIpAddress;
  staticAssetsServer: string = environment.staticAssetsServer;
  constructor() { }

  setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): any {
    try {
      const item = localStorage.getItem(key);

      return JSON.parse(item);
    } catch (e) {
      return null;
    }
  }

  getItemUnparsed(key: string): any {
    try {
      const item = localStorage.getItem(key);

      return item;
    } catch (e) {
      return null;
    }
  }

  removeItem(key: string): any {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.removeItem('currentQuestionIndex');
    localStorage.removeItem('pretestId');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('surveyId');
    localStorage.removeItem('test');
    localStorage.removeItem('testId');
    localStorage.removeItem('token');
    localStorage.removeItem('trainingId');
    localStorage.removeItem('trainingInfo');
    localStorage.removeItem('usrId')

  }
}
